module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "o4clnjpa",
    dataset: process.env.GATSBY_SANITY_DATASET || "production"
  }
};
